import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  standalone: false,
	selector: 'app-modal',
	templateUrl: './modal.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./modal.component.css'],
})
export class ModalComponent implements OnInit {
	dataModal: any = {
		titolo: '',
		body: '',
		modalColour: '',
		twoBtn: '',
	};

	constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) {}

	ngOnInit(): void {
		// Extract data from config instead of MAT_DIALOG_DATA
		const data = this.config.data;

		switch (data.modalType) {
			case 'custom':
				this.openModalCustom();
				break;
			case 'error':
				this.openModalError();
				break;
			case 'errordata':
				this.openModalErrorData();
				break;
			case 'success':
				this.openModalSuccess();
				break;
			case 'warningDelete':
				this.openModalWarningDelete();
				break;
			case 'publishData':
				this.openModalPublish();
				break;
		}
	}

	openModalCustom() {
		const data = this.config.data;
		this.dataModal.titolo = data.titolo;
		this.dataModal.body = data.body;
		this.dataModal.modalColour = data.modalColour;
		this.dataModal.twoBtn = data.twoBtn;
	}

	openModalError() {
		const data = this.config.data;
		this.dataModal.titolo = 'OPERAZIONE FALLITA';
		this.dataModal.body = data.body == null ? 'Operazione non andata a buon fine. Riprovare più tardi.' : data.body;
		this.dataModal.modalColour = 'modal-col-red';
	}

	openModalErrorData() {
		this.dataModal.titolo = 'ERRORE DATE';
		this.dataModal.body = 'La data di fine non può errese maggiore della data di inizio.';
		this.dataModal.modalColour = 'modal-col-red';
	}

	openModalSuccess() {
		const data = this.config.data;
		this.dataModal.titolo = data.titolo;
		this.dataModal.body = 'Operazione completata con successo!';
		this.dataModal.modalColour = 'modal-col-green';
	}

	openModalWarningDelete() {
		const data = this.config.data;
		this.dataModal.titolo = 'ELIMINAZIONE ' + data.subject + ' ' + data.subjectName;
		this.dataModal.body = 'Sei sicuro di voler eliminare ' + data.subjectName.toLocaleUpperCase() + '?';
		this.dataModal.modalColour = 'modal-col-orange';
		this.dataModal.twoBtn = 'true';
	}

	openModalPublish() {
		this.dataModal.titolo = 'pubblicazione';
		this.dataModal.body = 'sei sicuro di voler pubblicare i dati nel Client?';
		this.dataModal.modalColour = 'modal-col-orange';
		this.dataModal.twoBtn = 'true';
	}

	// Methods to close/confirm dialog
	close() {
		this.ref.close(false);
	}

	confirm() {
		this.ref.close(true);
	}
}
